import React from 'react'
import { BackdropStyle, ModalStyle, DrawerWrapper } from './CalendarDrawer.styled'

interface ModelProps {
  show: boolean
}

const CalendarDrawer: React.FC<ModelProps> = (props) => {
  return (
    <BackdropStyle isopen={props.show}>
      <DrawerWrapper isopen={props.show}>
        <ModalStyle>{props.children}</ModalStyle>
      </DrawerWrapper>
    </BackdropStyle>
  )
}
export default CalendarDrawer
